import { AxiosResponse } from 'axios';

import { HttpService } from '~system/api/base/http-service';

import { RequestParams } from '~app/types/api/requestParams';
import { getActiveScope } from '~app/utils/get-active-scope';

import {
  ApiLease,
  ApiProperty,
  ApiPropertyCreate,
  ApiPropertyUpdate,
  ApiTenant,
} from '~shared/types';

const propertyUrlBuilder = (id = '') => {
  const scope = getActiveScope();
  const separator = id ? '/' : '';

  return `${scope}/properties${separator}${id}`;
};

export const getProperties = async (
  params?: RequestParams
): Promise<ApiProperty[]> => {
  const requestUrl = propertyUrlBuilder();

  const { data }: AxiosResponse<ApiProperty[]> = await HttpService.get(
    requestUrl,
    params
  );

  return data;
};

export const getProperty = async (id: string) => {
  const requestUrl = propertyUrlBuilder(id);
  const { data }: AxiosResponse<ApiProperty> = await HttpService.get(
    requestUrl
  );

  return data;
};

export const getPropertyTenants = async (id: string) => {
  const requestUrl = propertyUrlBuilder(id);
  const { data }: AxiosResponse<ApiTenant[]> = await HttpService.get(
    `${requestUrl}/tenants`
  );

  return data;
};

export const getPropertyLeases = async (id: string) => {
  const requestUrl = propertyUrlBuilder(id);
  const { data }: AxiosResponse<ApiLease[]> = await HttpService.get(
    `${requestUrl}/leases`
  );

  return data;
};

export const createProperty = async (property: ApiPropertyCreate) => {
  const requestUrl = propertyUrlBuilder();
  const { data }: AxiosResponse<ApiProperty> = await HttpService.post(
    requestUrl,
    property
  );

  return data;
};

export const updateProperty = async (
  id: number,
  property: ApiPropertyUpdate
) => {
  const requestUrl = propertyUrlBuilder(`${id}`);
  const { data }: AxiosResponse<ApiProperty> = await HttpService.patch(
    requestUrl,
    property
  );

  return data;
};

export const deleteProperty = async (id: string) => {
  const requestUrl = propertyUrlBuilder(id);
  const { data }: AxiosResponse = await HttpService.delete(requestUrl);

  return data;
};
